













import { Component, Vue } from 'vue-property-decorator'
import { confirmEmail, resendEmailConfirmation } from '@/services/auth'
import { showToast } from '@/services/app'
import { defaultRoute } from '@/types/Users'
import usersStore from '@/store/users'

@Component({
  metaInfo: {
    title: 'Confirm email'
  }
})
export default class ConfirmEmail extends Vue {
  loading = false
  message = 'Confirming your email address...'
  valid: boolean | null = null

  async mounted() {
    this.loading = true
    try {
      if (!this.$route.query.token) {
        return showToast(this.$store, {text: 'No token provided'})
      }
      await confirmEmail(
        this.$store,
        this.$route.query.token as string,
        this.$route.query.email as string
      )
      this.message = 'Email confirmed.'
      this.valid = true

      setTimeout(this.openApp, 500)
    }
    catch (error) {
      this.message = 'Could not confirm email.'
      this.valid = false
    }
    this.loading = false
  }

  get me() {
    return this.$store.getters.me
  }

  openApp() {
    if (!this.me) {
      this.navigateToLogin()
    }
    else {
      this.$router.push({
        name: defaultRoute()
      })
    }
  }

  navigateToHome() {
    this.$router.push('/')
  }

  navigateToLogin() {
    this.$router.push({ name: 'signIn', params: {
      email: this.$route.query.email as string
    }})
  }

  resendEmail() {
    resendEmailConfirmation(this.$store, this.$route.query.email as string)
  }
}
